module OnlineDPR.Application.Client.Report.Table

open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Shared
open OnlineDPR.Application.Client.Report.Types
open OnlineDPR.Application.Client.Translations
open OnlineDPR.Application.Client.Components
open OnlineDPR.Application.Shared.Translations

let private getOriginIcon origin =
    match origin with
    | DprOrigin.OldDataImport -> i [ ClassName "fas fa-archive"
                                     Title (CurrentTranslations.Translations.[TranslationKey.Dpr_Origin_Import]) ] []
    | DprOrigin.Sync -> i [ ClassName "fas fa-exchange-alt"
                            Title (CurrentTranslations.Translations.[TranslationKey.Dpr_Origin_Sync]) ] []
    | DprOrigin.Manual -> i [ ClassName "fas fa-keyboard"
                              Title (CurrentTranslations.Translations.[TranslationKey.Dpr_Origin_Manual]) ] []
    | _ -> str ""

let private renderTableHead columns =
    [   tr  [] ( List.append [  th [] []
                                th [] [ str (CurrentTranslations.Translations.[TranslationKey.Dpr_IncludeInReport]) ]
                                th [ClassName "aggregation-column"] [ str (CurrentTranslations.Translations.[TranslationKey.Dpr_AggregatedSumValue]) ]
                                th [ClassName "aggregation-column"] [ str (CurrentTranslations.Translations.[TranslationKey.Dpr_AggregatedAverageValue]) ]
                             ]
                             (columns |> List.map (fun column -> th [ ] [ div [ ClassName "origin-icon" ] [ getOriginIcon column.Origin]
                                                                          str(column.Label) ] ) ) ) ]

let private renderCategoryRowLabel category dispatch =
    [ td [] [
        a [
            Href "#"
            OnClick (fun _ -> dispatch (ToggleCategoryVisibility category))
            ClassName "row-name"
        ] [
            (match List.isEmpty category.Subcategories with
             | true ->   span [ ClassName "empty-toggle-option" ] []
             | false ->  match category.SubcategoriesVisible with
                         | true -> i [ ClassName "fa fa-minus-square" ] []
                         | false -> i [ ClassName "fa fa-plus-square" ] [])
            span [] [ str (match category.TranslationKey with
                             | Some key -> CurrentTranslations.Translations.[key]
                             | None -> category.Name) ]
        ]
    ]]

let private renderRowCheckbox isChecked onChange isVisible =
    match isVisible with
    | true -> [ td [] [ slider isChecked false (Some onChange) None None ] ]
    | false -> [ td [] [] ]

let private renderAggregated value suffix isUpdating isVisible =
    match isVisible with
    | true ->[ td [ClassName "aggregation-column"] [ (match isUpdating with
                                                               | true -> spinner
                                                               | false -> str ((sprintf "%A" value) + suffix)) ] ]
    | false -> [ td [ClassName "aggregation-column"] [] ]

let private renderRowData data suffix length isUpdating =
    match List.isEmpty data with
    | true ->   [ td [ ColSpan length ] [] ]
    | false ->  data
                |> List.map (fun value -> match isUpdating with
                                          | true -> td [] [ spinner ]
                                          | false -> match value with
                                                     | a when a = invalidDatapoint -> td [] [ str "-" ]
                                                     | _ -> td [] [ str ((sprintf "%A" value) + suffix) ])

let private renderCategoryRow category length depth dispatch isUpdating : ReactElement list=
    [ tr
        [ Data ("level", depth) ]
        (List.concat [
            renderCategoryRowLabel category dispatch
            renderRowCheckbox category.IncludeInReport (fun _ -> dispatch (ToggleCategoryCheckbox category)) (not (List.isEmpty category.DataRow))
            renderAggregated category.AggregatedSumValue category.Suffix isUpdating (not (List.isEmpty category.DataRow))
            renderAggregated category.AggregatedAverageValue category.Suffix isUpdating (not (List.isEmpty category.DataRow))
            renderRowData category.DataRow category.Suffix length isUpdating])]


let rec private renderCategory category length depth dispatch isUpdating : ReactElement list =
    match category.SubcategoriesVisible with
    | false -> (renderCategoryRow category length depth dispatch isUpdating)
    | true ->  List.concat [
                    (renderCategoryRow category length depth dispatch isUpdating)
                    category.Subcategories
                        |> List.map (fun subsubcategory -> renderCategory subsubcategory length (depth + 1) dispatch isUpdating)
                        |> List.concat
                ]

let private renderTableBody model dispatch isUpdating : ReactElement list =
    model.Categories
        |> List.map (fun category -> renderCategory category model.Columns.Length 0 dispatch isUpdating)
        |> List.concat

let renderPageContent (model: ReportViewModel) dispatch isUpdating =
    let content = div [ Id "ReportTableContainer" ]
                      [ table[ ClassName "table table-hover table-condensed"
                               Id "Report" ]
                             [ thead [] (renderTableHead model.Columns)
                               tbody [] (renderTableBody model dispatch isUpdating) ]]
    card None content